// React Imports
import { useEffect, useState } from "react";

// Router Imports
import { useNavigate } from "react-router-dom";

// Component Imports
import { useDispatch } from "react-redux";
import ICONS from "../../../assets/Icons";
import { setHideBreadCrumb } from "../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../_utils/CommonStatus/StatusContainer";
import InfoCard from "../../_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import FormatAmount from "../../_utils/FormatAmount/FormatAmount";

const ReimbursementTxnMultiApprovalDeclined = () => {
  // 1️⃣ useNavigate
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // 2️⃣ useState
  const [declinedPageData, setdeclinedPageData] = useState([]);
  const [declinedPageID, setdeclinedPageID] = useState([]);

  // 3️⃣ Callback / Handler functions
  const buttonRows = [
    [
      {
        btnText: "Go to approval",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/view_all/go_to_approval_white_circle.svg",
        imgColor: "var(--positive-bg)",
        handleFunction: () => {
          navigate(
            "/reimbursement_transaction_dashboard/reimbursement_transaction_multi_approval",
            {
              replace: true,
            },
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        hoverOption: "black",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/view_all/go_to_dashboard.svg",
        imgColor: "var(--text-primary)",
        handleFunction: () => {
          navigate("/reimbursement_transaction_dashboard", {
            replace: true,
          });
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  const TransactionList = ({ transactions }) => (
    <div className="flex flex-col">
      {transactions?.map((account, i) => (
        <InfoCard
          key={account?.txn_id || i}
          bgColor="var(--positive-card)"
          hoverable="black"
          onClick={() =>
            navigate(
              `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
              {
                replace: true,
              },
            )
          }
          rows={[
            {
              leftTitle: (
                <>
                  INR <FormatAmount price={account?.amount} />
                </>
              ),
              leftSubTitle: "Amount",
              rightIcon: true,
              rightIconSrc: ICONS?.ARROW_RIGHT_WHITE,
              onClick: () =>
                navigate(
                  `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${account?.txn_id}`,
                  {
                    replace: true,
                  },
                ),
            },
            {
              leftTitle: account?.beneficiary_account_name,
              leftSubTitle: "Account name",
            },
          ]}
          showRowDivider={true}
          rowBorderColor={"var(--positive-bg)"}
        />
      ))}
    </div>
  );

  // 4️⃣ useEffect
  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedReimbursementTxnData"),
    );

    if (storedSelectedApproval) {
      setdeclinedPageData(storedSelectedApproval?.selectedSendTransactions);
      setdeclinedPageID(storedSelectedApproval?.selectedTransactions);
    } else {
      setdeclinedPageData([]);
      setdeclinedPageID([]);
    }
  }, []);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  return (
    <StatusContainer
      status="success"
      buttonRows={buttonRows}
      title={declinedPageID?.length && "Transactions rejected successfully."}
    >
      <TabsWeapperSection
        title={`Rejected transactions  - ${
          declinedPageID?.length || declinedPageData?.length
        }`}
      >
        <TransactionList transactions={declinedPageData} />
      </TabsWeapperSection>
    </StatusContainer>
  );
};

export default ReimbursementTxnMultiApprovalDeclined;
